import { ImageDown, LoaderCircle } from 'lucide-react';
import type { MediaKitAsset } from '../../lib/api/operatorConsole';
import { Button } from '../../components/ui/Button';
import { assetButtonLabel } from './mediaKitFormat';
import { useAssetDownload } from './useAssetDownload';

export function PackArtButton({ packId, asset }: { packId: number; asset: MediaKitAsset }) {
  const { pending, error, download } = useAssetDownload(packId, asset);

  return (
    <div className="flex flex-col gap-1">
      <Button
        variant="ghost"
        onClick={() => void download()}
        disabled={pending}
        aria-busy={pending}
        title={assetButtonLabel(asset)}
        className="gap-2"
      >
        {pending ? (
          <LoaderCircle size={16} className="animate-spin" aria-hidden="true" />
        ) : (
          <ImageDown size={16} aria-hidden="true" />
        )}
        Download pack art
      </Button>
      {error && (
        <p role="alert" className="text-[12px] text-[var(--co-error)]">
          {error}
        </p>
      )}
    </div>
  );
}
